export default "__VITE_PUBLIC_ASSET__94026947__"